import React from 'react';
import { cn } from '../../utils';
import styles from './ChatContentContainer.module.css';

export interface ChatContentContainerProps {
  className?: string;
  children: React.ReactNode;
}

export function ChatContentContainer({ className, children }: ChatContentContainerProps) {
  return (
    <div className={cn(styles.container, className)}>
      {children}
    </div>
  );
}
